import React from "react";
import "./DSS.css";
import Navbar from "./components/dss_components/Navbar";
import DSSContainer from "./components/dss_components/DSSContainer";
import AboutModal from "./webGIScomponents/AboutModal";
const DSS = () => {
  const [isModalVisible, setModalVisible] = React.useState(false);
  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };
  return (
    <div className="dss-page">
      <Navbar toggleModal={toggleModal} />
      {isModalVisible && <AboutModal toggleModal={toggleModal} />}
      <DSSContainer />
    </div>
  );
};

export default DSS;
